import { UserToReassign } from '../../common/types/UserToReassign';

const initialState = {
  reassignList: []
};

const reassignListSelector = (state = initialState): UserToReassign[] => state.reassignList;

export default reassignListSelector;
